'use strict';

import { CoreRepository } from '../CoreRepository';
import { AgencyPersonalToken } from '../../Entities/Agency/AgencyPersonalToken';
import { AgencyPersonalTokenCollection } from '../../Collections/Agency/AgencyPersonalTokenCollection';

export class AgencyPersonalTokenRepository extends CoreRepository {
  public createAgencyPersonalToken(agencyId: number, reference: string, payload: object = {}) {
    return this.webAPI.createAgencyPersonalToken(agencyId, reference, payload).then((response) => {
      const agencyPersonalToken = new AgencyPersonalToken();
      agencyPersonalToken.hydrate(response);

      return agencyPersonalToken;
    });
  }

  public deleteAgencyPersonalToken(agencyId: number, reference: string) {
    return this.webAPI.deleteAgencyPersonalToken(agencyId, reference).then((response) => {
      return response;
    });
  }

  public getAgencyPersonalToken(agencyId: number, reference: string, options: object = null) {
    return this.webAPI.getAgencyPersonalToken(agencyId, reference, options).then((response) => {
      return response;
    });
  }
  /*
    public getAgencyPersonalTokens(options: object = {}, criteria: object = null){
        if( !options )
        {
        options = {};
        }

        if( criteria )
        {
        options['criteria'] = criteria;
        }

        return this.webAPI.get(options)
        .then( response => {
            let collection = new AgencyPersonalTokenCollection();

            response.data.forEach(collectionItemData => {
            let collectionItem = new AgencyPersonalToken();
                collectionItem.hydrate(collectionItemData);

            collection.addItem(collectionItem);
            });

            collection.setOffset(response.offset);
            collection.setLimit(response.limit);
            collection.setTotal(response.total);

            return collection;
        });

    }
    */

  /*
    public getAgencyPersonalToken(options: object = null){
        if( !options )
        {
        options = {};
        }

        return this.webAPI.getAgencyPersonalToken(options)
        .then( response => {
            if( !response )
            {
            return false;
            }

            let AgencyPersonalToken = new AgencyPersonalToken();
            AgencyPersonalToken.hydrate(response);

            return AgencyPersonalToken;
        });
    }

   

    public updateAgencyPersonalToken(payload: object = {}){  
        return this.webAPI.updateAgencyPersonalToken(payload)
        .then( response => {
            let AgencyPersonalToken = new AgencyPersonalToken();
            AgencyPersonalToken.hydrate(response);

            return AgencyPersonalToken;
        });
    }

    public removeAgencyPersonalToken( ){
        return this.webAPI.removeAgencyPersonalToken()
        .then( response => {
            return response;
        });
    }
    */
}
